
export const mealvaultFAQs = [
    {
        question: '1. What is MealVault?',
        text: `MealVault is a privacy-first app that lets you store, organize, and access your recipes completely offline\nor through your personal iCloud account.`
    },
    {
        question: '2. Do I need to create an account to use MealVault?',
        text: `No. MealVault doesn’t require you to create an account or sign in.\nAll your data stays on your device or in your iCloud account.`
    },
    {
        question: '3. Is my data private?',
        text: `Yes. Your content is never sent to our servers or shared with anyone.\nIt stays completely private—stored either on your device or securely in iCloud.`
    },
    {
        question: '4. What happens if I delete the app?',
        text: `If you’re using iCloud, your data may still be available when you reinstall.\nIf not using iCloud, deleting the app may also delete your local data.\nMake sure to back up important information if needed.`
    },
    {
        question: '5. Can I use MealVault on multiple devices?',
        text: `Yes, if you have iCloud enabled and use the same Apple ID across devices, 
        your content should sync automatically.`
    },
    {
        question: '6. Does MealVault work offline?',
        text: `Yes. You can access and manage your meals offline.\niCloud syncing will resume once you're back online.`
    },
    {
        question: '7. Does MealVault support images or just text?',
        text: `Yes. You can add up to three images for each recipe.`
    },
    {
        question: '8. Do you collect any analytics or usage data?',
        text: `No. We do not collect any analytics, usage data, or personal information.\nPrivacy is at the core of MealVault.`
    },
    {
        question: '9. Can I export or share my recipes?',
        text: `Recipes can be imported and exported as MealVault files. To export a recipe please use the share button.\nThen the file can be shared with AirDrop or any other messaging app.`
    },
    {
        question: '10. Is there a easier way to add the ingredients and steps to the recipe, then adding them manually?',
        text: `Yes. Ingredients and steps can be added with an image. The image will be scanned and the detected ingredients and steps will added.\nIt has to be done seperately for the ingredients and steps.\n Note that this feature is still in BETA.`
    }
]